<template>
  <v-dialog
    width="800"
    v-model="isLegalTermsVisible"
    persistent
  >
    <v-card>
      <v-card-title class="headline teal darken-4 white--text" primary-title>
      Termos Legais
      </v-card-title>

      <v-card-text>
        <div
            v-if="mode === 'save'"
            class="ml-3 mb-2 subheading font-weight-bold"
        >
            Por favor, leia e aceite os termos legais para prosseguir:
        </div>
        <div class="legal-terms pa-3">
          <legal-terms-text />
        </div>
      </v-card-text>
      <v-checkbox
          v-if="mode === 'save'"
          class="mt-0 ml-4"
          label="Eu li e aceito os Termos Legais"
          v-model="agreed"
          style="height: 25px;"
      />
      <v-card-actions>
      <v-spacer />
      <v-btn
          v-if="mode === 'save'"
          color="primary"
          flat
          @click="agreeWithTerms"
          :disabled="!agreed"
      >
          Salvar
      </v-btn>
      <v-btn
          v-if="mode === 'read'"
          color="primary"
          flat
          @click="$emit('toggleLegalTerms', false);"
      >
          Fechar
      </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LegalTermsText from './LegalTermsText';

export default {
  name: 'LegalTermsDialog',
  components: {
    LegalTermsText
  },
  props: {
    isLegalTermsVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
    mode: {
      type: String,
      default: 'save',
      required: true,
    },
  },
  data() {
    return {
      agreed: false,
    };
  },
  methods: {
    agreeWithTerms() {
      this.$store.dispatch('acceptLegalTerms')
        .then(() => {
          this.$store.dispatch('getCurrentUser');
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .legal-terms {
    max-height: 314px;
    overflow-y: scroll;
  }
</style>
